import { render } from "./StocktakeLoader.vue?vue&type=template&id=68b67170"
import script from "./StocktakeLoader.vue?vue&type=script&lang=js"
export * from "./StocktakeLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__